import DropDown, { IDropDownProps } from "../../plugins/DropDown";
import { $, on } from "../../utils/dom";

export const onContentLoaded = (): void => {
  const el = $(".js-dropDown__auth");
  if (el) {
    const dropDownConfig: IDropDownProps = {
      contentId: "header-nav-auth",
      el,
      openButtonClass: "-iconArrowUp",
      closedButtonClass: "-iconArrowDown",
    };
    DropDown(dropDownConfig);
  }
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
